import { IResponse } from "models";

export enum ActionType {
  CONTRACT_INFORMATION = "action/CONTRACT_INFORMATION",
  CONTRACT_INFORMATION_SUCCESS = "action/CONTRACT_INFORMATION_SUCCESS",
  CONTRACT_INFORMATION_ERROR = "action/CONTRACT_INFORMATION_ERROR",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IContractInformationResponse extends IResponse {
  result: {
    address: string;
    application_plan: string;
    agreement_doc_file_size: any;
    auto_release: boolean;
    bank_detail: any;
    company_pdfs_count: number;
    company_representation: string;
    contact_number: string;
    contract_start_date: string;
    days_until_auto_release: any;
    email: string;
    monthly_point: number;
    name: string;
    payment_details: any[];
    remark: string;
    start_date: string;
  };
}
